import React from "react";

export interface CloseButtonProps {
    onClick: () => void;
}

export const CloseButton:React.FC<CloseButtonProps> = ({onClick}) => <button
    className="navbar-close p-2 hover:bg-black/70 rounded-full transition-colors duration-200 group"
    onClick={onClick}
    aria-label="Close menu"
>
    <svg
        className="h-6 w-6 text-gray-200 group-hover:text-white transition-colors"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
        ></path>
    </svg>
</button>